module.exports = __webpack_public_path__ + "static/img/2_bye_bye.925554dc.jpg";